module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.student.firstname) + " " + _vm._s(_vm.student.lastname))])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.student.lastname))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Vorname")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.student.firstname))])]), _vm._v(" "), (_vm.student.origin) ? _c('tr', [_c('th', [_vm._v("Herkunftsort")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.student.origin))])]) : _vm._e(), _vm._v(" "), (_vm.student.notes) ? _c('tr', [_c('th', [_vm._v("Bemerkungen")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.student.notes))])]) : _vm._e()]), _vm._v(" "), (_vm.student.hasRegistrations) ? _c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.student.registrations), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.semester_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.faculty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.date))])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.student.hasRecords) ? _c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._l((_vm.student.records), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.source))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.details))])])
  }), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('tr', {
    staticClass: "noprint"
  }, [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "sources"
    }
  }, [_vm._v("Bio-bibliographische Nachweise")])], 1)])])])], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('h1', [_vm._v("Immatrikulationen")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Semester")]), _vm._v(" "), _c('th', [_vm._v("Fakultät/Fach")]), _vm._v(" "), _c('th', [_vm._v("Datum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('h1', [_vm._v("Belege")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Quelle")]), _vm._v(" "), _c('th', [_vm._v("Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "noprint"
  }, [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('hr', {
    attrs: {
      "size": "1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bddcc25"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Student.vue
// module id = 90
// module chunks = 1